import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useToaster } from '@components/toaster';

import { api } from 'api';

import { Loading } from 'components/Loading';
import { Modal, ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

type Props = ModalProps<{
  applicationId: number;
  applicationName: string;
}>;

export const RetractApplicantModal = (props: Props) => {
  const { applicationId, applicationName, closeModal } = props;
  const { applicationStore, t } = useStore();
  const { showError, showSuccess } = useToaster();

  const queryClient = useQueryClient();

  const submit = useMutation(() => api.applications.retract(applicationId), {
    onSuccess: () => {
      setTimeout(() => queryClient.invalidateQueries(['applicants']), 2000);
      applicationStore.retract(applicationId);
      showSuccess(t('application.retract.success', applicationName));
      closeModal();
    },
    onError: () => {
      showError(t('application.retract.error', applicationName));
    },
  });
  return (
    <Modal>
      <Modal.Header text={t('retractmodal.title')} />
      <Stack space={4}>
        <Text text={t('retractmodal.confirmtext')} />
        <Text font="bold16" text={applicationName + '?'} />
        {submit.isLoading && <Loading />}
      </Stack>
      <Modal.Actions>
        <Button
          variant="secondary"
          isDisabled={submit.isLoading}
          onClick={closeModal}
          text={t('retractmodal.button.cancel')}
        />
        <Button
          isDisabled={submit.isLoading}
          onClick={() => submit.mutate()}
          text={t('retractmodal.button.submit')}
        />
      </Modal.Actions>
    </Modal>
  );
};
